import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  input,
  Output,
} from '@angular/core';

import { ButtonComponent } from '@shared/components/button/button.component';
import { AuxIconName } from '@shared/components/icon/icon';
import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TooltipDirective, ButtonComponent],
  selector: 'aux-checklist-row-title',
  styleUrls: ['../../quarter-close-checklist.component.scss'],
  templateUrl: './checklist-row-title.component.html',
})
export class ChecklistRowTitleComponent {
  complete = input('0');
  total = input('0');

  sectionCompleted = computed(() => {
    const complete = this.complete();
    const total = this.total();

    return complete !== '0' && complete === total;
  });

  disabledLock = input(false);
  icon = input.required<AuxIconName>();
  isLoadingList = input(false);
  pendoID = input('');
  title = input('');
  tooltip = input('');

  @Output() lockAllEmit = new EventEmitter<void>();
}
